













































































































































































































































































































































































import Vue from 'vue';
import Tabs from "../../../components/Tabs.vue";
import store, { TransactionStore } from "../services/TransactionStore";
import TransactionItemDimension, { TransactionItemDimensionDefaultProps } from '../models/TransactionItemDimension';
import TransactionItem from '../models/TransactionItem';
import InvoiceMirror from '../models/InvoiceMirror';
import BasicGridDimensionWrapper from './BasicGridDimensionWrapper.vue';
import LookupComboBox from "./LookupComboBox.vue";
import { t } from "@/plugins/i18n";


const baseColumns = [
      {
        field: "id",
        title: " ",
        cell: 'command',
        width: "100px"
      },
      {
        field: "dimCodeName",
        title: t("DimenzioKod"),
        cell: "dimCodeName",
      },
      {
        field: "total",
        title: t("Osszeg"),
        cell: "totalTemplate",
      },
];
const endColumns = [
    { 
      width: "0px", 
      filterable: false,
    },
];


interface Data {
  store: TransactionStore;
}

interface Methods {
  preSetItems(e: any): void;
  onRowClick(item: any): void;
  confirmDelete(item: TransactionItemDimension): void;
  showDeleteTemplate(item: TransactionItemDimension): void;
  setDimCodeType(num: number): void;
  setDefaultSelectedValues(num: number): void;
  onSelectedProjectUpdate(value: any, item: TransactionItemDimension): void;
  onSelectedPoUpdate(value: any, item: TransactionItemDimension): void;
  onValueChanged(item: TransactionItemDimension): void;
  onCarValueChanged(item: TransactionItemDimension, newValue: any): void;
  onStationValueChanged(item: TransactionItemDimension, newVal: any): void;
  onUserValueChanged(item: TransactionItemDimension, newVal: any): void;
  onToolValueChanged(item: TransactionItemDimension, newVal: any): void;
  productions(projectID: number): object[]; 
  checkChange(item: any, codeField: string, idField: string, nameField: string): void;
  handleChange(item: TransactionItemDimension, codeField: string, idField: string, nameField: string): void;
}
interface Computed {
  dim4columns: any;
  dim5columns: any;
  dim6columns: any;
  dim7columns: any;
  dim8columns: any;
  dim9columns: any;
  dim10columns: any;
  dim11columns: any;
  dim12columns: any;
  positiveNegativeItem: TransactionItem;
  positiveNegativeDimensionCodeType: number;
  positiveNegativeDimension: TransactionItemDimension;
  activeDimensions: TransactionItemDimension[];
}

interface Props {
  positiveNegative: string;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  mounted() {
    this.$emit('register-focus', [this.$refs.newDim])
  },
  props: {
    positiveNegative: {type: String},
  },

  components: {
    Tabs,
    BasicGridDimensionWrapper,
    LookupComboBox,
  }, 

  data() {
    return {
      store,
    }
  },

  
  methods: {
    preSetItems(e: any) {
      const type = e.currentTarget.dataset.type;
      this.setDimCodeType(type);
    },
    onRowClick(item){
      store.selectedDimension = item.dataItem;
      this.positiveNegativeDimension = item.dataItem
    },
    confirmDelete(item){
      this.$emit('deleteDimItem',item);
      // Kiürült a rács: az "Új tétel létrehozás" gomb kapja a fókuszt, hogy egyből folytatható a
      // munka. (Amíg van sor, a rács a helyére lépő sor Dimenzió kód mezőjét fókuszálja.)
      this.$nextTick(() => {
        if(this.activeDimensions.length > 0)
          return;
        (this.$refs.newDim as any)?.$el?.focus();
      });
    },
    showDeleteTemplate(item){
      item.deleting = !item.deleting
    },
    setDimCodeType(num){
      this.positiveNegativeDimensionCodeType = num;
    },
    setDefaultSelectedValues(num){
      const array = this.store.transactionItemsDimensions.filter(x => x.head == this.positiveNegativeItem.id && x.dimCodeType == num);
      if(array.length > 0){
        this.positiveNegativeDimension = array[0];
      }
      else{
        this.positiveNegativeDimension = {...TransactionItemDimensionDefaultProps};
      }
    },
    onSelectedProjectUpdate(val,item){
      item.project = val.id;
      item.projectMainCode = val.mainCode;
      item.projectName = val.name;
      item.projectCode = val.code;
      item.poId = 1;
      item.workNumber = "-";
    },
    onSelectedPoUpdate(val,item){
      if(val as object){
        item.poId = val.id;
        item.workNumber = val.workNumber
      }
      else{
        console.log("nem objektum")
        // item.workNumber = "-";
        // item.poId = 1
      }

    },
    productions(projectID){
      if(projectID === 1)
        return this.store.pos;
      
      return this.store.pos.filter((i: any) => i.project == projectID)
    },
    onValueChanged(item){
      const ogItem = store.originalTransactionItemsDimensions.find(x => x.id === item.id)
      if(!ogItem)
          return
      
      const fieldsToCheck: (keyof TransactionItemDimension)[] = ['extProdParts','carId','extProdPartner','project','poId','userId','stationId','toolId']
      for (const key of fieldsToCheck) {
          if(item[key] != ogItem[key]){
            const exists = this.store.modifiedDimensions.some(x => x.id === item.id);
            if (!exists) {
                this.store.modifiedDimensions.push(item);
            }
            return
          }
      }

      this.store.modifiedDimensions = this.store.modifiedDimensions.filter(x=> x.id !== item.id)
    },
    onCarValueChanged(item, newVal){
      item.carId = newVal.id,
      item.regNum = newVal.reqNum
    },
    onStationValueChanged(item, newVal){
      item.stationName = newVal.name
      item.stationId = newVal.id

      item.userName = item.toolName = "-"
      item.userId = item.toolId = 1
    },
    onUserValueChanged(item,newVal){
      item.userName = newVal.name
      item.userId = newVal.id

      item.stationName = item.toolName = "-"
      item.stationId = item.toolId = 1
    },
    onToolValueChanged(item,newVal){
      item.toolName = newVal.name
      item.toolId = newVal.id

      item.stationName = item.userName = "-"
      item.stationId = item.userId = 1
    },
    async checkChange(item, codeField, idField, nameField) {
      if (!item[codeField]) {
        item[idField] = 1;
        nameField != "" ? item[nameField] = "-" : nameField;
        return;
      }
      let isValid: any;
      if(nameField != ""){
        isValid = await this.store.isValidPartCode(item[codeField]);
      }
      else{
        isValid =  await this.store.ValidPartnerName(item[codeField])
      }

      if (isValid.id > 1) {
        item[idField] = isValid.id;
        nameField != "" ? item[nameField] = isValid.name : nameField;
      } else {
        item[idField] = 1;
        nameField != "" ? item[nameField] = "-" : nameField;
      }
    },
    async handleChange(item, codeField, idField, nameField){
      try {
        await this.checkChange(item, codeField,idField,nameField);
        this.onValueChanged(item);
      } catch (err) {
        console.error(err);
      }
    },
  },
  

  computed: {
    dim4columns: () =>[
      ...baseColumns,
      ...endColumns
    ],
    dim5columns: () =>[
      ...baseColumns,
      {
        field: "extProdPartsCode",
        title: t("Cikkszam"),
        cell: "partsCode"
      },
      {
        field: "extProdPartsName",
        title: t("Transactions_GyariAlkatresz"),
      },
      ...endColumns
    ],
    dim6columns: () => [
      ...baseColumns,
      {
        field: "parts",
        title: t("GyartottTermek")
      },
      {
        field: "partsCode",
        title: t("Cikkszam"),
        cell: "partsCode"
      },
      {
        field: "partsName",
        title: t("Transactions_GyariAlkatresz")
      },
      {
        field: "stock",
        title: t("KeszletID")
      },
      {
        field: "production",
        title: t("Transactions_GyariLejelentes")
      },
      ...endColumns
    ],
    dim7columns: () => [
      ...baseColumns,
      {
        field: "carId",
        title: t("Gepjarmu"),
        cell: "car"
      },
      {
        field: "regNum",
        title: t("Rendszam"),
        cell: "regNum"
      },
      ...endColumns

    ],
    dim8columns: () => [
      ...baseColumns,
      {
        field: "userName",
        title: t("Munkatars"),
        cell: "userName"
      },
      {
        field: "stationName",
        title: t("Munkaallomas"),
        cell: "stationName"
      },
      {
        field: "toolName",
        title: t("Szerszam"),
        cell: "toolName"
      },
      ...endColumns
    ],
    dim9columns: () => [
      ...baseColumns,
      {
        field: "project",
        title: t("Transactions_ProjektID"),
        cell: "projectID"
      },
      {
        field: "projectName",
        title: t("Nev")
      },
      {
        field: "projectMainCode",
        title: t("BelsoID"),
      }, 
      {
        field: "projectCode",
        title: t("KulsoID")
      },  
      {
        field: "poId",
        title: t("Megrendeles"),
        cell: "poId"
      },  
      {
        field: "workNumber",
        title: t("Munkaszam")
      },
      ...endColumns
    ],
    dim10columns: () => [
      ...baseColumns,
      {
        field: "extProdPartner",
        title: t("Transactions_KiegeszitoPartnerID")
      },
      {
        field: "extProdPartnerName",
        title: t("PartnerNev"),
        cell: "extProdPartnerName"
      },
      ...endColumns
      
    ],
    dim11columns: () => [
      ...baseColumns,
      {
        field: "accGroupName",
        title: t("Koltseghely")
      },
      ...endColumns

    ],
    dim12columns: () => [ 
      ...baseColumns,
      {
        field: "projectName",
        title: t("Nev"),
        cell: "projectName"
      },
      {
        field: "projectMainCode",
        title: t("BelsoID")
      }, 
      {
        field: "projectCode",
        title: t("KulsoID")
      },  
      {
        field: "workNumber",
        title: t("Munkaszam"),
        cell: "workNumber"
      },
      ...endColumns

    ],
    positiveNegativeItem(){
      return this.$props.positiveNegative == "positive" ? this.store.positiveSelectedItem : this.store.negativeSelectedItem;
    },
    positiveNegativeDimension:{
      get() {
        return this.$props.positiveNegative == "positive" ? this.store.positiveSelectedDimension : this.store.negativeSelectedDimension;
      },
      set(newVal) {
        if (this.$props.positiveNegative === "positive") {
          this.store.positiveSelectedDimension = newVal;
        } else {
          this.store.negativeSelectedDimension = newVal;
        }
      }
    },
    positiveNegativeDimensionCodeType: {
      get() {
      return this.$props.positiveNegative == "positive" ? this.store.positiveSelectedDimCodeType : this.store.negativeSelectedDimCodeType;
      },
      set(newVal) {
        if (this.$props.positiveNegative === "positive") {
          this.store.positiveSelectedDimCodeType = newVal;
        } else {
          this.store.negativeSelectedDimCodeType = newVal;
        }
      }
    },
    activeDimensions(){
      return store.transactionItemsDimensions.filter((x) => 
      x.dimCodeType == this.positiveNegativeDimensionCodeType && 
      (
        x.head != 0 
        ? x.head == this.positiveNegativeItem.id 
        : this.positiveNegativeItem.newTransactionItemDimensions.includes(x) )
      )
      .map(item =>
        {
          item.selected = item === this.store.selectedDimension;
          item.inEdit = item === this.store.selectedDimension;
          return item;
        }
      );
    }
  },
  watch:{
    activeDimensions:{
      handler(newVal,oldVal) {
        if(newVal[0] != oldVal[0]){
          this.setDefaultSelectedValues(this.positiveNegativeDimensionCodeType);
        }
      },deep: true
    },
    positiveNegativeItem(){
      const keys: (keyof InvoiceMirror)[] =  ['dim4', 'dim5', 'dim6', 'dim7', 'dim8', 'dim9', 'dim10', 'dim11', 'dim12'];
      const index = keys.findIndex(key => Number(this.positiveNegativeItem.invoiceMirror[key]) != 2);
      if(index >= 0){
        this.setDimCodeType(index+5);
        
      }else{
        this.setDimCodeType(5);
      }
      (this.$refs.tab as any).setTab(index);
    }
  }
})
